export default __webpack_public_path__ + "static/moving-home-de05f8b55e1eda803891a70de1e574a1.png";